import { useMemo } from "react";

/**
 * Detects mobile platform via User-Agent (not viewport width).
 * A desktop browser resized to 767px should NOT trigger app banners.
 */
export default function useMobilePlatform() {
  return useMemo(() => {
    const ua = navigator.userAgent || "";

    const isIOS =
      /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

    const isAndroid = /Android/.test(ua);

    const isMobile = isIOS || isAndroid;

    const isRecorderBot =
      new URLSearchParams(window.location.search).get("recorder") === "true";

    return { isIOS, isAndroid, isMobile, isRecorderBot };
  }, []);
}
